import React from 'react';
import './style.scss';
import clsx from 'clsx';
import AppHeaderMenuAccordion from './menuAccordion/index.js';
import AppHeaderMenuNavLinks from './navLinks/index.js';

const AppHeaderMobileMenu = React.forwardRef(
  ({ className, opened, isEliteTheme, ...props }, ref) => {
    const navItems = props?.fields.items[1]?.fields?.items || [];
    const menuItems = props?.fields.items[0]?.fields?.items || [];
    const languages = props?.fields.navigationLanguages;

    return (
      <div
        ref={ref}
        className={clsx(
          'app-header-mobile-menu',
          !opened && 'app-header-mobile-menu-hidden',
          className
        )}
      >
        <AppHeaderMenuAccordion items={menuItems} />
        <AppHeaderMenuNavLinks items={navItems} languages={languages} isEliteTheme={isEliteTheme} />
      </div>
    );
  }
);
AppHeaderMobileMenu.displayName = 'AppHeaderMobileMenu';

export default AppHeaderMobileMenu;
